import EnvDecisionInterface from "./EnvDecisionInterface.js";

class EnvDecisionDomain extends EnvDecisionInterface {
    constructor() {
        super()
    }

    get = () => {
        const { hostname } = window.location;
        // if the hostname starts with dev
        // then the env is dev
        if (hostname.startsWith("dev")) {
            return "dev";
        }

        // if the hostname starts with local, or is an ip address
        // then the env is local
        const ipAddrRegex = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/;
        if (hostname.startsWith("local") || ipAddrRegex.test(hostname)) {
            return "local";
        }

        // otherwise default to prod
        return "prod";
    }
}

export default EnvDecisionDomain;
